<ami-dialog-message [setting]="message"></ami-dialog-message>
<pg-branch-store-create
  *ngIf="open.create"
  (close)="onCloseCreate()"
></pg-branch-store-create>

<pg-branch-store-update
  *ngIf="open.update"
  (close)="onCloseUpdate()"
  [row]="itemToUpdate"
></pg-branch-store-update>

<div class="card">
  <ami-head [settings]="settingsAmiHead"> </ami-head>
  <ami-table
    [settings]="table.settings"
    [data]="table.data"
    (action)="onReciveAction($event)"
  ></ami-table>
</div>
